(() => {
  if (window.synergyBuildCart) return;
  window.synergyBuildCart = true;
  let busy = false;
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-cb-remove-build]');
    if (!button) return;
    event.preventDefault();
    if (busy) return;
    busy = true;
    button.disabled = true;
    const error = button.closest('.cb-cart-group').querySelector('[data-cb-cart-error]');
    error.hidden = true;
    const root = window.Shopify?.routes?.root || '/';
    const code = button.dataset.cbRemoveBuild;
    const read = async () => {
      const response = await fetch(`${root}cart.js`, {credentials:'same-origin', cache:'no-store'});
      if (!response.ok) throw new Error('Your cart could not be checked. Please try again.');
      return response.json();
    };
    const finish = () => {
      if (document.dispatchEvent(new CustomEvent('cb:cart-removed', {cancelable:true}))) window.location.reload();
    };
    try {
      const cart = await read();
      const lines = cart.items.filter((line) => line.properties?._cb_build === code);
      if (!lines.length) { finish(); return; }
      const response = await fetch(`${root}cart/update.js`, {
        method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json'},
        body:JSON.stringify({updates:Object.fromEntries(lines.map((line) => [line.key, 0]))}),
      });
      if (!response.ok) throw new Error('This design could not be removed. Please try again.');
      finish();
    } catch (failure) {
      try {
        const cart = await read();
        if (!cart.items.some((line) => line.properties?._cb_build === code)) { finish(); return; }
      } catch { /* Keep a clear retry path when the result cannot be established. */ }
      error.textContent = failure.message;
      error.hidden = false;
    } finally { busy = false; button.disabled = false; }
  });
})();
